// lazy load images
const lazyImages = [].slice.call(document.querySelectorAll('img.def-lazy'));

if ('IntersectionObserver' in window) {
  const lazyImageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const lazyImage = entry.target;
        lazyImage.src = lazyImage.dataset.src;
        lazyImage.classList.remove('def-lazy');
        lazyImageObserver.unobserve(lazyImage);
      }
    });
  });

  lazyImages.forEach((lazyImage) => {
    lazyImageObserver.observe(lazyImage);
  });
} else {
  // Possibly fall back to event handlers here
  console.error(`IntersectionObserver = ${window.IntersectionObserver}`);
}
